<div
  class="idp-dynamic-banner"
  *ngIf="
    config?.deviceConfig?.desktopEnabled || config?.deviceConfig?.mobileEnabled
  "
  [ngClass]="getDynamicClass()"
  [ngSwitch]="config.templateType"
>
  <ng-container *ngSwitchCase="'fullimagebanner'">
    <div class="full-image-banner-view">
      <idp-banner-fullimage
        [content]="content"
        [config]="config"
        [styles]="styles"
      ></idp-banner-fullimage>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'splitbanner'">
    <div class="split-image-banner-view">
      <idp-banner-split
        [content]="content"
        [config]="config"
        [styles]="styles"
      ></idp-banner-split>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'slimbanner'">
    <div class="slim-image-banner-view">
      <idp-banner-slim
        [content]="content"
        [config]="config"
        [styles]="styles"
      ></idp-banner-slim>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'alertbanner'">
    <div class="alert-image-banner-view">
      <idp-banner-alert
        [content]="content"
        [config]="config"
        [styles]="styles"
      ></idp-banner-alert>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'iconbanner'">
    <div class="icon-image-banner-view">
      <idp-banner-icon
        [content]="content"
        [config]="config"
        [styles]="styles"
      ></idp-banner-icon>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div>&nbsp;</div>
  </ng-container>
</div>
